module.exports = {
      id: "slider-prev-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#slider-prev",
      toString: function () {
        return this.url;
      }
    }